export default {
  currencySymbol: '$'
}
